import { create } from "zustand";
import { FILTER_VALUES } from "@/constants/filters";
import { DEFAULT_SHARED_TIME_RANGE } from "@/constants/timeRange";
const DEFAULT_FILTERS = {
    timeRange: DEFAULT_SHARED_TIME_RANGE,
    selectedApiKey: FILTER_VALUES.ALL
};
const useAuditLogsStoreBase = create((set)=>({
        filters: {
            ...DEFAULT_FILTERS
        },
        actions: {
            setTimeRange: (timeRange)=>set((state)=>({
                        filters: {
                            ...state.filters,
                            timeRange
                        }
                    })),
            setSelectedApiKey: (selectedApiKey)=>set((state)=>({
                        filters: {
                            ...state.filters,
                            selectedApiKey
                        }
                    })),
            resetFilters: ()=>set({
                    filters: {
                        ...DEFAULT_FILTERS
                    }
                })
        }
    }));
export default function useAuditLogsStore() {
    const filters = useAuditLogsStoreBase((state)=>state.filters);
    const actions = useAuditLogsStoreBase((state)=>state.actions);
    return {
        filters,
        ...actions
    };
}
export const auditLogsStore = useAuditLogsStoreBase;
